export default function (Vue) {
    Vue.auth = {
        setToken(token, expiration, refresh){
            localStorage.setItem('stedisa_token', token);
            localStorage.setItem('stedisa_expiration', expiration);
            localStorage.setItem('stedisa_refresh_token', refresh);
        },

        getToken(){
            var token = localStorage.getItem('stedisa_token');
            var expiration = localStorage.getItem('stedisa_expiration');
            var refresh = localStorage.getItem('stedisa_refresh_token');

            if(!token || !expiration){
                return null;
            }

            if(Date.now() > parseInt(expiration)){
                this.destroyToken();
                return null;
            }else{
                return token;
            }
        },

        destroyToken(){
            localStorage.removeItem('stedisa_token');
            localStorage.removeItem('stedisa_expiration');
            localStorage.removeItem('stedisa_refresh_token');
        },

        isAuth(){
            if(this.getToken()){
                return true;
            }else{
                return false;
            }
        }
    }

    Object.defineProperties(Vue.prototype, {
        $auth: {
            get: () => {
                return Vue.auth
            }
        }
    });
}
